import { useState } from 'react';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import {
  Form,
  FormField,
  FormItem,
  FormControl,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import Error from '@/components/common/Error';
import SpinnerButton from '@/components/common/SpinnerButton';

import { usePostCard } from '@/data/card';

const formSchema = z.object({
  is_confirmed: z.boolean().refine((val) => val === true, {
    message: 'You must confirm that you want to generate a new card link.'
  })
});

const CreateCardLinkForm = ({ userId, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState('');
  const postCard = usePostCard();
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      is_confirmed: false
    }
  });

  const onSubmit = async () => {
    try {
      setSubmitting(true);
      setApiError('');
      const newCard = await postCard({ userId });
      await onSuccess(newCard);
      setSubmitting(false);
    } catch (err) {
      setApiError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="is_confirmed"
          render={({ field }) => (
            <FormItem className="">
              <div className="flex items-center gap-2 space-y-0 ">
                <FormControl className="flex items-center ">
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
                <FormLabel>I want to generate a card link</FormLabel>
              </div>
              <FormMessage />
            </FormItem>
          )}
        />
        {apiError && <Error error={apiError} />}

        <div className="flex justify-end">
          <SpinnerButton loading={submitting}>Generate Card Link</SpinnerButton>
        </div>
      </form>
    </Form>
  );
};

export default CreateCardLinkForm;
